import React from "react";
import { pageTitle } from "../../helpers/PageTitle";
import { siteContact } from "../../data/siteContact";

export default function PrivacyPage() {
  pageTitle("Privacy Policy");
  return (
    <main className="mx-auto max-w-4xl px-6 pb-20 pt-40 text-slate-700">
      <h1 className="mb-6 text-4xl font-bold text-slate-900">Privacy Policy</h1>
      <p className="mb-8 text-sm text-slate-500">Last updated: September 4, 2026</p>
      <div className="space-y-6 leading-8">
        <p>Algostine collects information you submit through our contact form, such as your name, email, phone number, service interest, and project brief.</p>
        <p>We use this information to respond to inquiries, provide requested services, improve our website, and meet legal obligations. We do not sell personal data or use advertising cookies.</p>
        <p>Form submissions are processed by Formspree. Hosting and analytics providers may process limited technical information under their applicable retention and security policies.</p>
        <p>To request access, correction, deletion, or information about your data, contact <a className="text-brand-teal underline" href={siteContact.emailHref}>{siteContact.email}</a>.</p>
      </div>
    </main>
  );
}
